import React from "react";
import { Box, Typography } from "@mui/material";

const ActivityBar = ({ activity }) => (
  <Box display="flex" alignItems="center" gap={1}>
    <Box
      sx={{
        width: 100,
        height: 8,
        borderRadius: 4,
        bgcolor: "#ccc",
        overflow: "hidden"
      }}
    >
      <Box
        sx={{
          width: `${activity}%`,
          height: "100%",
          bgcolor: "#1976d2"
        }}
      />
    </Box>
    <Typography variant="body2">{activity}%</Typography>
  </Box>
);

export default ActivityBar;